import {useMe} from "../../../hooks/useGetUser";
import profile from "../../../images/profileImage.png";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {userRoleList} from "../../../utils/constants";
import ImageComponent from "../shared/ImageComponent";
import Coverimage from "../../../images/Cover Technicien.png";
import Loader from "../shared/Loader";
import StarIcon from "../../../images/icons/starIcon";
import CrownIcon from "../../../images/icons/crownIcon";
import CameraIcon from "../../../images/icons/CameraIcon";
import {useEffect, useRef, useState} from "react";
import QueryErrorState from "../shared/QueryErrorState";
const ProfileBanner = ({modifProfile, profileFile, setProfileFile}) => {
  const {data, isLoading, isError, error, refetch} = useMe();
  const [profilePreview, setProfilePreview] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!profileFile) {
      setProfilePreview("");
    }
  }, [profileFile]);

  useEffect(
    () => () => {
      if (profilePreview) URL.revokeObjectURL(profilePreview);
    },
    [profilePreview],
  );
  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfilePreview(imageUrl);
      setProfileFile(file);
    }
  };
  const {imageUri, firstName, lastName, selectedRole} = data;
  const profileImage = profilePreview || buildImageUrl(imageUri);

  return (
    <div className="lg:col-span-4 w-full">
      <div className="profile w-full bg-white !rounded-xl  px-3 pt-3 pb-0">
        <div className="profile-head">
          <div className="photo-content hidden md:flex">
            {selectedRole === userRoleList.TECHNICIAN ? (
              <img
                alt="cover"
                src={Coverimage}
                className="min-h-[106px]  w-full rounded-xl object-cover"
              />
            ) : (
              <img
                alt="cover"
                src={Coverimage}
                className="min-h-[106px]  w-full rounded-xl object-cover"
              />
            )}
          </div>
          <div className="profile-info !flex p-2 md:!p-0  md:ml-12 ">
            <div className="profile-photo min-w-20 w-20 md:h-10 !mt-0 md:!-mt-[20px] relative ">
              {modifProfile && (
                <div
                  onClick={() => {
                    fileInputRef.current?.click();
                  }}
                  className="w-5 h-5 bg-white text-[#1A64B9] rounded-full flex justify-center items-center absolute bottom-2  md:-bottom-8 right-0 cursor-pointer shadow-md"
                >
                  <CameraIcon className="w-4 aspect-square" />
                </div>
              )}
              <input
                ref={fileInputRef}
                type="file"
                onChange={handleImage}
                multiple={false}
                className="hidden"
              />
              {!!data?.avgRating && (
                <a
                  href="#avis"
                  className="bg-[#FFC107] w-[40px] flex justify-center gap-[2px] items-center leading-none px-[3px] py-[2px] text-white text-[12px] absolute bottom-0  md:-bottom-11 !rounded-lg left-[50%] -translate-x-[50%] "
                >
                  {Number(data?.avgRating).toFixed(2)}
                  <StarIcon className="fill-white stroke-none w-3 h-3" />
                </a>
              )}
              {!!profileImage ? (
                <ImageComponent
                  src={profileImage}
                  className="w-20 rounded-full aspect-square ring-4 ring-white object-cover "
                  alt="profile"
                  fallback={
                    <img
                      src={profile}
                      className="w-20 rounded-full aspect-square ring-4 ring-white object-cover"
                      alt="profile"
                    />
                  }
                />
              ) : (
                <img
                  src={profile}
                  className="w-20 rounded-full aspect-square ring-4 ring-white object-cover"
                  alt="profile"
                />
              )}
            </div>
            <div className=" flex-grow !flex justify-between">
              <div className="profile-name px-3 !pt-4 !pb-5">
                <div className=" text-[#19295C] font-bold capitalize mb-0">{`${lastName} ${firstName}`}</div>
                <div className="flex justify-start items-center gap-2 text-[#FF6600] font-normal text-sm">
                  {selectedRole === userRoleList.TECHNICIAN
                    ? "Prestataire"
                    : "Client"}
                  {/* <i className="fi fi-rr-chess-queen flex items-center"></i> */}
                  {selectedRole === userRoleList.TECHNICIAN
                    ? !!data?.Technician?.taxRegistrationNumber && (
                        <div title="Professionnel">
                          <CrownIcon className="w-4 h-4 m-0" />
                        </div>
                      )
                    : null}
                </div>
              </div>
              {!modifProfile && (
                <div className="flex justify-end items-center">
                  <div className="hidden md:flex justify-center h-full border-l border-solid items-center py-[14px] px-8 text-[#19295C] font-bold text-sm ">
                    {selectedRole === userRoleList.TECHNICIAN
                      ? (data?.Technician?.viewCount ?? 0)
                      : (data?.Client?.viewCount ?? 0)}{" "}
                    vue(s)
                  </div>
                  <div className="hidden md:flex gap-2 justify-center h-full border-l border-solid items-center py-[14px] px-8 text-[#19295C] font-bold text-sm ">
                    <div className="w-2 h-2 bg-green-600 rounded-full" />
                    Disponible
                  </div>
                  {/* <div className="flex gap-2 justify-end h-full md:border-l border-solid items-center py-[14px] pl-8 text-[#19295C] font-bold text-lg ">
                  {!!modifProfile ? (
                    <Link
                      to={"/mon-profil"}
                      className=" !rounded-lg flex gap-2  justify-center items-center px-4 py-[14px] bg-[#D5E3F3] hover:text-[#1A64B9] hover:opacity-80 text-[#1A64B9] "
                    >
                      <i className="fi fi-rr-user flex items-center"></i>
                      <span className="hidden md:flex text-sm">
                        Voir mon profil
                      </span>
                    </Link>
                  ) : (
                    <Link
                      to={"/mon-compte"}
                      className=" !rounded-lg flex gap-2  justify-center items-center px-4 py-[14px] bg-[#D5E3F3] hover:text-[#1A64B9] hover:opacity-80 text-[#1A64B9] "
                    >
                      <i className="fi fi-rr-user-pen flex items-center"></i>
                      <span className="hidden md:flex text-sm">
                        Modifier mon profil
                      </span>
                    </Link>
                  )}
                </div> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileBanner;
